import { toast } from "react-toastify";

type NotificationType = "success" | "error" | "warning";

export const notify = (message: string, type?: NotificationType, options: any = {}) => {
  const msg = `${message[0].toUpperCase()}${message.substr(1)}`;

  options = {
    icon: true,
    ...options,
  };

  if (type === "success") {
    toast.success(msg, { ...options, style: { ...options.style } });
  } else if (type === "error") {
    toast.error(msg, { ...options, style: { ...options.style } });
  } else if (type === "warning") {
    toast.warning(msg, { ...options, style: { ...options.style } });
  } else {
    toast(message, options);
  }
};
